module.exports = __webpack_public_path__ + "static/media/in-the-beginning-was-the-word.79b6197e.txt";